module.exports = __webpack_public_path__ + "static/media/galleryImage06.fb34d2d5.jpg";